import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import AddToCompanyWorkers from './AddToCompanyWorkers';

export default class SelectRating extends Component {
  static propTypes = {
    rateWorkers: PropTypes.func.isRequired,
    isWorkersToAddFavorite: PropTypes.bool
  };

  state = {
    rating: null,
    comments: '',
    fav_status: null
  };

  maxValue = 5;

  handleChangeRate = rating => {
    this.setState({ rating, fav_status: null });
  };

  handleTypeComment = e => {
    this.setState({ comments: e.target.value });
  };

  handleFavStatus = status => this.setState(prevState => {
    let fav_status = status;

    if (prevState.fav_status === fav_status) {
      fav_status = null;
    }

    return { fav_status };
  });

  handleSubmit = () => {
    const { rating, comments, fav_status } = this.state;
    const payload = { rating, comments };

    if (fav_status !== null) {
      payload.fav_status = fav_status;
    }

    this.props.rateWorkers(payload);
  };

  _renderStars = () => {
    const { rating } = this.state;
    const stars = [];
    for (let i = 1; i <= this.maxValue; i++) {
      let isSelected = i <= rating;
      let star = (
        <button
          className={`rating-star ${isSelected ? 'selected' : ''}`}
          onClick={() => this.handleChangeRate(i)}
          key={i}
        >
          <FontAwesomeIcon icon={faStar} />
        </button>
      );
      stars.push(star);
    }
    return stars;
  };

  render () {
    const { rating, comments } = this.state;
    return (
      <React.Fragment>
        <h4 className='tip-rate-title'>
          <label>Select Rating</label>
        </h4>
        <div className='rate-stars-wrapper'>
          { this._renderStars() }
        </div>
        <h4 className='tip-rate-title'>
          <label htmlFor='rate-comment-id'>Comment</label>
        </h4>
        <input
          id='rate-comment-id'
          className='tip-rate-input'
          type='text'
          value={comments}
          onChange={this.handleTypeComment}
        />

        <AddToCompanyWorkers
          handleFavStatus={this.handleFavStatus}
          rating={rating}
          isWorkersToAddFavorite={this.props.isWorkersToAddFavorite}
          fav_status={this.state.fav_status}
        />

        <button
          className={`button button-primary mt-4 submit-tips-rates-button ${rating ? '' : 'disabled'}`}
          onClick={this.handleSubmit}
        >Submit</button>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/jobDetails/TipsAndRates/SelectRating.js